/**
 * 判断是否是外部链接
 * @param { String } path 路径
 * @return { Boolean } 是为true，否则为false
 */
function isExternal(path) {
  const reg = /^https?/;
  return reg.test(path);
}

/**
 * 是否是整数
 * @param { String } value 值
 * @return 是为true，否则为false
 */
function isInteger(value) {
  const reg = /^\d+$/;
  return reg.test(value);
}

/**
 * 是否是数字
 * @param { String } value 值
 * @return 是为true，否则为false
 */
function isNumber(value) {
  const reg = /^(-)?(([0-9])|([1-9]([0-9]+)))(.[0-9]+)?$/;
  return reg.test(value);
}

/**
 * 是否是非法字符 "：34 '：39 /：47 <：60 >：62 \：92
 * @param { String } value 值
 * @param { Boolean } exclude 是否排除 <>
 * @return 是为true，否则为false
 */
function isIllegalChar(value, exclude = false) {
  let validate = false;
  if (value.indexOf('$') >= 0) {
    return true;
  }
  for (let i = 0; i < value.length; i++) {
    if (
      value.charCodeAt(i) === 34 ||
      value.charCodeAt(i) === 39 ||
      (
        exclude ? value.charCodeAt(i) === 47
          : value.charCodeAt(i) === 60 || value.charCodeAt(i) === 62
      ) ||
      value.charCodeAt(i) === 92
    ) {
      validate = true;
    }
    if (validate) {
      break;
    }
  }
  return validate;
}

export {
  isExternal,
  isInteger,
  isNumber,
  isIllegalChar
};